import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import { IAgent } from '@interfaces/IAgent';
import AgentService from '@services/Distributor';
import { Button } from 'antd';
import _ from 'lodash';
import findIndex from 'lodash/findIndex';
import React from 'react';

import ApiResponseDisplayer from '../components/ApiResponseDisplayer';
import FormBuilder from '../components/Form';
import Modal from '../components/Modal';
import Page from '../components/Page';
import Table from '../components/TableComponent';
import { AgentForm } from '../forms/Agent';
import NotificationComponent from '../helpers/_showNotifications';
import I18n from '../i18n';
import AppContext from '../services/Context';
import styled from '../styled-components';

type PropType = { history: { replace: Function }; match: any; }

type StateType = {
    isLoading: boolean;
    iconLoading?: boolean;
    showFormModal: boolean;
    tableData: IAgent[];
    agentAmount?: number;
    totalShowData?: number;
    curOffset?: string;
    disabled?: boolean;
    search: string;
    filter?: boolean;
    filteredTableData: IAgent[];
    editItem?: IAgent;
    serverResponse: any;
};

const tableColumns = [{
    title: 'table.agents.code',
    dataIndex: 'code',
    key: 'code',
}, {
    title: 'table.agents.name',
    dataIndex: 'name',
    key: 'name',
    class: 'name'
}, {
    title: 'table.agents.email',
    dataIndex: 'email',
    key: 'email',
}, {
    title: 'table.agents.createdAt',
    dataIndex: 'createdAt',
    key: 'createdAt',
}, {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
}];

class Agents extends React.Component<PropType, StateType> {

    private idUnit: any = undefined;
    private _service: AgentService = new AgentService();
    private _idDistributor = this.props.match.params.id;

    constructor (props: any) {
        super(props);
    }

    state = {
        isLoading: true,
        showFormModal: false,
        iconLoading: false,
        tableData: [],
        agentAmount: 0,
        totalShowData: 5,
        filteredTableData: [],
        curOffset: undefined,
        disabled: undefined,
        search: '',
        filter: false,
        editItem: {
            code: '',
            id: undefined,
            adminUser: undefined,
            unit: this.idUnit,
            disabled: false,
            name: '',
            email: ''
        },
        serverResponse: undefined,
    };

    setUnit (unitId: string) {
        this.idUnit = unitId;
    }

    componentDidMount () {
        console.log('to aqui')
        this.getAgents(true, true);
    }

    toggleFormModal = () =>
        this.setState({
            showFormModal: !this.state.showFormModal,
            serverResponse: undefined,
            editItem: {
                code: '',
                id: undefined,
                adminUser: undefined,
                unit: this.idUnit,
                disabled: true,
                name: '',
                email: ''
            },
        });

    getAgents = async (reset: boolean, showLoading: boolean) => {
        this.setState({ showFormModal: false });
        if (reset) {
            this.setState({
                curOffset: undefined,
                showFormModal: false,
                isLoading: true,
            });
        }

        try {

            const data: any = await this._service.agentlist(this._idDistributor, this.idUnit);
            let dataTableCreate: any = [];
            data.map((item: any) => {
                dataTableCreate.push({
                    code: item.code,
                    id: item.id,
                    name: item.name,
                    email: item.admin ? item.admin.email : '',
                    createdAt: item.createdAt,
                    disabled: item.disabled
                })
            })
            let newDataTableCreate: IAgent[] = [];
            if (!reset) {
                newDataTableCreate = this.state.tableData || [];
            }
            newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
            this.setState({
                isLoading: false,
                iconLoading: false,
                agentAmount: data.count,
                tableData: newDataTableCreate,
                curOffset: data.offset
            });
        } catch (error) {
            console.warn('Error ====', error);
            this.setState({
                isLoading: false,
            });
        }
    };

    openEditModal = (editItem: IAgent) => {
        this.setState({ editItem, showFormModal: true });
    };

    onSubmit = async (input: any, actions: { setSubmitting: Function }) => {
        const { tableData, editItem } = this.state;
        try {

            let nextTableData: IAgent[] = [];

            if (!!input.id) {
                const response = await this._service.updateById(input.id, input, this.idUnit);
                const targetIndex = findIndex(
                    tableData,
                    (item: IAgent) => item.id === response.id,
                );
                nextTableData = tableData;
                if (nextTableData[targetIndex]) {
                    nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
                }

            } else {
                const phoneInput = input.phone ? `+${input.phone.replace(/[^0-9]/g, '')}` : '';
                const data = {
                    code: input.code,
                    name: input.name,
                    admin: {
                        email: input.email,
                        phone: phoneInput
                    },
                    unit: this.idUnit
                }
                const response: any = await this._service.agentAdd(this._idDistributor, data, this.idUnit);
                const resFormat = {
                    code: response.code,
                    id: response.id,
                    name: response.name,
                    email: response.admin.email,
                    phone: response.admin.phone,
                    createdAt: response.createdAt,
                    disabled: response.disabled
                }
                nextTableData = [resFormat, ...tableData];
            }
            const dataTableCreate: any = [];
            nextTableData.map((item: any) => {
                dataTableCreate.push({
                    code: item.code,
                    id: item.id,
                    name: item.name,
                    email: item.email,
                    phone: item.phone,
                    createdAt: item.createdAt,
                    disabled: item.disabled
                })
            })
            this.setState({
                isLoading: false,
                showFormModal: false,
                tableData: nextTableData,
            });
        } catch (error) {
            NotificationComponent.Notify('error', 'Erro ao cadastrar', error);
        } finally {
            actions.setSubmitting(false);
        }
    };

    activeAgent = async (active: boolean, id: string) => {
        try {
            // TODO: confirmar com Modal

            const { tableData } = this.state;
            const targetIndex = findIndex(
                tableData,
                (item: IAgent) => item.id === id,
            );

            if (active) {
                tableData[targetIndex] = Object.assign(tableData[targetIndex], { disabled: false });
                await this._service.agentEnable(this._idDistributor, id, this.idUnit);
            } else {
                tableData[targetIndex] = Object.assign(tableData[targetIndex], { disabled: true });
                await this._service.agentDisable(this._idDistributor, id, this.idUnit);
            }

            this.setState({
                isLoading: false,
                tableData,
            });

        } catch (e) {
            console.error(e);
        }
    };

    deleteAgent = async (id: string) => {
        try {
            const { tableData } = this.state;
            const nextTableData = tableData.filter((item: IAgent) => item.id !== id);
            this.setState({
                isLoading: false,
                tableData: nextTableData,
            });
            await this._service.agentDel(this._idDistributor, id, this.idUnit);

        } catch (e) {
            console.error(e);
        }
    };

    loadMoreHistory = async (total: number) => {
        this.setState({
            iconLoading: true,
            totalShowData: total + 10
        })
        this.getAgents(false, false);
    }

    filterData = async (status: any) => {
        this.setState({
            isLoading: true
        })
        let filterTableData: IAgent[] = [];
        try {
            if (status === undefined) {
                this.setState({
                    isLoading: false,
                    disabled: status,
                    filter: false,
                })
            } else {
                _.some(this.state.tableData, (o: any) => {
                    if (o.disabled === status) {
                        filterTableData.push(o)
                    }
                })
                this.setState({
                    isLoading: false,
                    filteredTableData: filterTableData,
                    disabled: status,
                    filter: true
                })
            }

        }
        catch (err) {
            console.log(err)
        }
    }

    searchData = async (event: any) => {

        let searchTableData: IAgent[] = [];
        const SearchValue = event === '' ? false : event.target.find.value;
        await this.setState({
            search: SearchValue,
            isLoading: true,
        })

        if (!SearchValue) {
            this.getAgents(true, false);
        }
        try {
            _.some(this.state.tableData, (o: any) => {
                if (_.includes(o.name, SearchValue) || _.includes(o.code, SearchValue)) {
                    searchTableData.push(o)
                }
            })
            await this.setState({
                isLoading: false,
                tableData: searchTableData
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    render () {
        const {
            isLoading,
            showFormModal,
            tableData,
            filteredTableData,
            editItem,
            agentAmount,
            serverResponse,
            totalShowData,
            filter,
            search
        } = this.state;

        if (!!isLoading) {
            return (
                <Page>
                    <AppContext.Consumer>
                        {({ locale, activeUnitId }) => (
                            this.setUnit(activeUnitId),
                            <span>{I18n.l('common.loadingTable')}</span>
                        )}
                    </AppContext.Consumer>
                </Page>
            );
        }

        return (
            <Page>
                <AppContext.Consumer>
                    {({ locale, theme }) => (
                        <Wrapper>
                            <Toolbar>
                                <ToolbarItem>
                                    <RegisterBtnComponent
                                        onClick={this.toggleFormModal}
                                        buttonText={I18n.l('common.register') + " " + I18n.l('labels.agent')}
                                    />
                                </ToolbarItem>
                                <ToolbarItem>
                                    <SearchComponent
                                        onSubmit={this.searchData}
                                        placeholder='form.placeholders.agentsSearch'
                                        defaultValue={search}
                                        buttonText='form.buttons.search'
                                    />
                                </ToolbarItem>
                            </Toolbar>
                            {tableData.length > 0 && (
                                <div className={"goepik-component-tablesize"}>
                                    <Table
                                        columns={tableColumns}
                                        data={filter ? filteredTableData : tableData}
                                        onDelete={this.deleteAgent}
                                        noPagination={true}
                                        showConfirmationModal={false}
                                    />
                                </div>
                            )}
                            {agentAmount >= 10 && (
                                <Button
                                    className="loading-more"
                                    type="primary"
                                    loading={this.state.iconLoading}
                                    onClick={() => this.loadMoreHistory(totalShowData)}
                                    size='large'
                                    ghost
                                >
                                    {I18n.l('common.seeMore')}
                                </Button>
                            )}

                            {tableData.length === 0 && <p>{locale && I18n.l('common.noResult')}</p>}
                            {showFormModal && (
                                <Modal onClose={this.toggleFormModal} isOpen={showFormModal}>
                                    <ModalTitle>{I18n.l('form.titles.agentsForm')}</ModalTitle>
                                    <ModalContent>
                                        <FormBuilder
                                            settings={AgentForm}
                                            onSubmit={this.onSubmit}
                                            onCancel={this.toggleFormModal}
                                            data={[
                                                { name: 'code', value: editItem.code },
                                                { name: 'id', value: editItem.id },
                                                { name: 'name', value: editItem.name },
                                                { name: 'email', value: editItem.email }
                                            ]}
                                        />
                                        {serverResponse && (
                                            <ApiResponseDisplayer theme={theme} locale={locale} data={serverResponse} />
                                        )}
                                    </ModalContent>
                                </Modal>
                            )}
                        </Wrapper>
                    )}
                </AppContext.Consumer>
            </Page>
        );
    }
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  .loading-more {
      margin: 15px 0;
      padding: 0;
      border: 0;
      text-align: left
  }

  .filter-group {
      margin-bottom: 50px;
  }
`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;

  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
  width: 100%;
`;

export default Agents;
